/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/1
 * @updateTime 2021/9/1
 * @decription 公共组件 =》 滑动单元格右滑删除组件入口js
 */
export default {
    name: 'cc-swipe-cell-right-delete',
    // 混入
    mixins: [],
    // 依赖组件
    components: {},
    // 参数
    props: {
        // 数据
        data: {
            type: Object,
            required: true
        },
        // 显示的标题属性
        title: {
            type: String | Function,
            default: 'sqrmc'
        },
        // 显示的值属性
        value: {
            type: String,
            default: 'sqrlx'
        }
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-cc-swipe-cell-right-delete'
            },
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        },

        /**
         * 获取title的值
         * @returns {String}
         * */
        getTitle() {
            // 如果是函数，则获取对应的值
            if (typeof this.title === 'function') {
                return this.title(this.data);
            }
            return this.data[this.title];
        }
    },
    // 监听
    watch: {},
    // 创建完成
    created() {
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 点击信息项事件
         * @returns {void}
         * */
        eClickItem() {
            this.$emit('click', this.data);
        },

        /**
         * 点击删除事件
         * @returns {void}
         * */
        eClickDelete() {
            this.$emit('delete', this.data);
        }
    }
};
